import { useNavigate } from "react-router-dom";
import styles from "./bottom-box.module.css";
export default function BottomBox() {
  const navigate = useNavigate();
  return (
    <div className="container">
      <div className={styles.actionBoxWrapper}>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className={styles.footerActionBox}>
              <div className={styles.imageWrapper}>
                <img
                  src={"/assets/image/user.svg"}
                  className={styles.userImageLarger}
                />
              </div>
              <div>همکاری با ما</div>
              <button onClick={() => navigate("/job/intro")}>
                ارسال رزومه
                <i className="fa fa-arrow-left" />
              </button>
              <div className={styles.rotateSquare} />
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className={styles.footerActionBox}>
              <div className={styles.imageWrapper}>
                <img src={"/assets/image/document.svg"} />
              </div>
              <div>مشتریان بانکی</div>
              <button
                onClick={() =>
                  (window.location.href = "https://sm.isc.iranet.net/Login#!/")
                }
              >
                ورود
                <i className="fa fa-arrow-left" />
              </button>
              <div className={styles.rotateSquare} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
